import { render, staticRenderFns } from "./LoginCard.vue?vue&type=template&id=4e8df91c&scoped=true&"
import script from "./LoginCard.vue?vue&type=script&lang=js&"
export * from "./LoginCard.vue?vue&type=script&lang=js&"
import style0 from "./LoginCard.vue?vue&type=style&index=0&id=4e8df91c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8df91c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
